import React, { useState } from "react";
import { Settings, Bell, Moon, Globe } from "lucide-react";

export default function Preferences() {
  const [darkMode, setDarkMode] = useState(true);
  const [language, setLanguage] = useState("English");
  const [notifications, setNotifications] = useState(true);

  return (
    <div className="p-3 text-white text-[0.7rem] space-y-3">
      {/* Header */}
      <h1 className="text-[0.75rem] font-semibold flex items-center gap-2 text-slate-200 mb-2 tracking-wide">
        <Settings className="w-[14px] h-[14px] text-blue-400" />
        Preferences
      </h1>

      {/* Settings Section */}
      <div className="space-y-2">
        <SettingToggle
          icon={<Moon className="w-[12px] h-[12px] text-yellow-400" />}
          label="Dark Mode"
          enabled={darkMode}
          onToggle={() => setDarkMode(!darkMode)}
        />

        <SettingToggle
          icon={<Bell className="w-[12px] h-[12px] text-green-400" />}
          label="Notifications"
          enabled={notifications}
          onToggle={() => setNotifications(!notifications)}
        />

        {/* Language Selector */}
        <div className="bg-slate-900/70 border border-slate-800 rounded-md p-2">
          <div className="flex items-center gap-2 mb-1 text-slate-300">
            <Globe className="w-[12px] h-[12px] text-blue-400" />
            <span className="font-medium text-[0.7rem]">Language</span>
          </div>
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="w-full bg-slate-800 text-[0.68rem] text-slate-300 rounded px-2 py-[4px] border border-slate-700 focus:outline-none focus:ring-1 focus:ring-blue-500"
          >
            <option>English</option>
            <option>Arabic</option>
            <option>Swahili</option>
            <option>Hindi</option>
          </select>
        </div>
      </div>
    </div>
  );
}

function SettingToggle({ icon, label, enabled, onToggle }) {
  return (
    <div className="bg-slate-900/70 border border-slate-800 rounded-md p-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-slate-300">
        {icon}
        <span className="text-[0.68rem]">{label}</span>
      </div>
      <button
        onClick={onToggle}
        className={`px-2 py-[2px] rounded-full text-[0.65rem] font-semibold transition ${
          enabled
            ? "bg-blue-700/80 text-white"
            : "bg-slate-700 hover:bg-slate-600"
        }`}
      >
        {enabled ? "On" : "Off"}
      </button>
    </div>
  );
}
